import React from 'react'
import { Routes, Route, useNavigate, useParams } from 'react-router-dom'
import { useNavigate, useParams } from 'react-router-dom'

import CircularProgress from '@mui/material/CircularProgress'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import { DataGrid } from '@mui/x-data-grid'
import FormControlLabel from '@mui/material/FormControlLabel'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'

import useStateObject from '~/client/hooks/useStateObject'
import { useQuery, useCommand } from '~/client/hooks/cqrpc'
import useToggle from '~/client/hooks/useToggle'

import Link from '~/client/components/Link'
import Heading from '~/client/components/Heading'
import Loading from '~/client/components/Loading'
import ButtonRow from '~/client/components/ButtonRow'
import ErrorMessage from '~/client/components/ErrorMessage'
import DocumentTypeCreateForm from '~/client/components/DocumentTypeCreateForm'
import Timestamp from '~/client/components/Timestamp'
import LoadingList from '~/client/components/LoadingList'
import JSONEditor from '~/client/components/JSONEditor'
import DocumentTypeFormPreview from '~/client/components/DocumentTypeFormPreview'
import JSONSchemaFormInput from '~/client/components/JSONSchemaFormInput'
import InspectObject from '~/client/components/InspectObject'

export default function Page(props) {
  const { documentTypeId } = useParams()
  const query = useQuery('documentTypes.getById', { id: documentTypeId })
  const documentType = query.result
  return <Container>
    {query.loading
      ? <Loading/>
      : <Editor {...{documentType}}/>
    }
  </Container>
}


function Editor({ documentType }){
  const [uiSchema, setUiSchema] = React.useState(documentType.uiSchema)
  const [data, setData] = React.useState({})
  return <Stack direction="row" spacing={2}>
    <JSONEditor {...{
      sx: { flex: '0 0 50%' },
      value: uiSchema,
      onChange: setUiSchema,
    }}/>
    <Paper sx={{flex: '0 0 50%', p: 2}}>
      <Stack sx={{mb: 2}}>
        <Heading underlined>PREVIEW</Heading>
        <ButtonRow>
          <Button onClick={() => { setData({}) }}>RESET</Button>
        </ButtonRow>
      </Stack>
      <JSONSchemaFormInput {...{
        schema: documentType.schema,
        uiSchema,
        value: data,
        onChange: setData,
      }}/>
    </Paper>
  </Stack>
}
